(function () {
  function initFaqs(root) {
    if (!root || root.dataset.faqsReady === 'true') return;
    root.dataset.faqsReady = 'true';

    var links = root.querySelectorAll('[data-faqs-nav]');
    var panels = root.querySelectorAll('[data-faqs-panel]');
    if (!links.length || !panels.length) return;

    function setActive(key) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-faqs-nav') === key);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var key = link.getAttribute('data-faqs-nav');
        var panel = root.querySelector('[data-faqs-panel="' + key + '"]');
        if (!panel) return;

        event.preventDefault();
        setActive(key);
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + panel.id);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(entry.target.getAttribute('data-faqs-panel'));
            }
          });
        },
        {
          root: null,
          rootMargin: '-20% 0px -55% 0px',
          threshold: 0
        }
      );

      panels.forEach(function (panel) {
        observer.observe(panel);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-faqs-section]').forEach(initFaqs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector
      ? event.target.querySelector('[data-faqs-section]')
      : null;
    if (section) {
      section.dataset.faqsReady = 'false';
      initFaqs(section);
    }
  });
})();
